import { UnsubscribableEmailType } from '@constants';

import { RequestService } from '../request/request.service';

import { IUserSettings } from './user-settings.contract';

export class UserSettingsService extends RequestService {
  public constructor(apiUrl: string) {
    super(apiUrl);
  }

  public getByUserId = async (userId: string) => {
    return this.fetcher<IUserSettings>(`/user-settings/${userId}`);
  };

  public getMyUserSettings = async () => {
    return this.fetcher<IUserSettings>(`/user-settings/me`);
  };

  public updateAllowEmailNotifications = async (
    userId: string,
    allowedEmailNotifications: Partial<Record<UnsubscribableEmailType, boolean>>
  ) => {
    return this.putter<IUserSettings, { allowEmailNotifications: Partial<Record<UnsubscribableEmailType, boolean>> }>(
      `/user-settings/${userId}/allow-email-notifications`,
      { allowEmailNotifications: allowedEmailNotifications }
    );
  };

  public updateExamGroupMaster = async (userId: string, isActive: boolean) => {
    return this.putter<IUserSettings, { isActive: boolean }>(
      `/user-settings/${userId}/exam-group/master`,
      { isActive }
    );
  };

  public updateExamGroupNotifications = async (
    userId: string,
    examGroupNotifications: Array<{ tag: string; autonomousCommunities: string[] }>
  ) => {
    return this.putter<IUserSettings, { examGroupNotifications: Array<{ tag: string; autonomousCommunities: string[] }> }>(
      `/user-settings/${userId}/exam-group/notifications`,
      { examGroupNotifications }
    );
  };
}


